export default {
  methods: {
    query() {
      this.ing = true;
      this.handleFetch
        .call(this, this.filter.val, this.page)
        .then(resp => {
          const list = (this.respListKey 
            ? resp[ this.respListKey ] 
            : resp
          ) || [];
          this.list.model = list;
          if (this.page) {
            this.page.totalCount = resp.totalCount;
          }
        })
        .catch(() => this.ing = false);
    }
  }
};